import { createSelector } from "reselect";

const selectBrokerClosingReasonsState = state => state.lenderCallLogBrokerClosingReasonsStore || {};

export const selectBrokerClosingReasons = createSelector(
  [selectBrokerClosingReasonsState],
  state => state.brokerClosingReasons || [],
);
